/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Started_ToastInputs */

const en_ocr_started_toast = /** @type {(inputs: Ocr_Started_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting OCR analysis...`)
};

const fr_ocr_started_toast = /** @type {(inputs: Ocr_Started_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Début de l'analyse OCR...`)
};

const de_ocr_started_toast = /** @type {(inputs: Ocr_Started_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR-Analyse wird gestartet...`)
};

const it_ocr_started_toast = /** @type {(inputs: Ocr_Started_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvio dell'analisi OCR...`)
};

const ru_ocr_started_toast = /** @type {(inputs: Ocr_Started_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начало анализа OCR...`)
};

const es_ocr_started_toast = /** @type {(inputs: Ocr_Started_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando el análisis OCR...`)
};

const zh_cn2_ocr_started_toast = /** @type {(inputs: Ocr_Started_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始OCR分析……`)
};

const ja_ocr_started_toast = /** @type {(inputs: Ocr_Started_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR分析を開始します...`)
};

const hi_ocr_started_toast = /** @type {(inputs: Ocr_Started_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओसीआर विश्लेषण शुरू हो रहा है...`)
};

const pt_pt2_ocr_started_toast = /** @type {(inputs: Ocr_Started_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando a análise de OCR...`)
};

/**
* | output |
* | --- |
* | "Starting OCR analysis..." |
*
* @param {Ocr_Started_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_started_toast = /** @type {((inputs?: Ocr_Started_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Started_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_started_toast(inputs)
	if (locale === "de") return de_ocr_started_toast(inputs)
	if (locale === "it") return it_ocr_started_toast(inputs)
	if (locale === "ru") return ru_ocr_started_toast(inputs)
	if (locale === "es") return es_ocr_started_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_started_toast(inputs)
	if (locale === "ja") return ja_ocr_started_toast(inputs)
	if (locale === "hi") return hi_ocr_started_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_started_toast(inputs)
	return en_ocr_started_toast(inputs)
});